import React, { Component } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import Loader from "shared/components/Loader";
import { setIframeAsLoaded } from "store/actions/editorActions";
import { EditorFrameWrapper } from "./styles";

class Frame extends Component {
  state = {
    loaded: false,
  };

  handleLoad = (e) => {
    const { setIframeAsLoaded } = this.props;
    setIframeAsLoaded();
    this.setState({ loaded: true });
    setTimeout(() => {
      const iframeLoader = document.getElementById("iframe-loader");
      iframeLoader && iframeLoader.remove();
    }, 300);
  };

  render() {
    const { src } = this.props;
    const { loaded } = this.state;

    const loaderClasses = cx("loader-container", { loaded });
    const frameClasses = cx("editor-frame", { loaded });

    return (
      <EditorFrameWrapper>
        <div id="iframe-loader" className={loaderClasses}>
          <Loader />
        </div>
        <iframe
          className={frameClasses}
          title="Editor"
          src={src}
          onLoad={this.handleLoad}
        />
      </EditorFrameWrapper>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  setIframeAsLoaded,
};

export default connect(mapStateToProps, mapDispatchToProps)(Frame);
